import OpenApp from 'features/plaid/screens/OpenApp/OpenApp';
import React from 'react';

export default function OpenAppPage() {
  return <OpenApp />;
}
